/* eslint-disable no-case-declarations */
import { combineReducers } from 'redux';
import {
  RESET_USER_MARGIN,
  FETCH_USER_MARGIN_FAILURE,
  FETCH_USER_MARGIN_REQUEST,
  FETCH_USER_MARGIN_SUCCESS,
  UPDATE_USER_MARGIN_RETRY_AFTER_TIMER,
  USER_MARGIN_LIST_CACHE,
  USER_MARGIN_LIST_UPDATE_FILTERS,
  USER_MARGIN_LIST_SORTING,
} from '../../constants/ActionTypes';
import { readBuffer } from '../../utils';
import storage from '../../storage';

export const USER_MARGIN_TABLE_SORT = 'USER_MARGIN_TABLE_SORT';
export const USER_MARGIN_TABLE_FILTER = 'USER_MARGIN_TABLE_FILTER';
export const USER_MARGIN_TABLE_POSITION_STATE =
  'USER_MARGIN_TABLE_POSITION_STATE';

const getFilterFromStorage = () => readBuffer(USER_MARGIN_TABLE_FILTER) || {};
const getSortFromStorage = () => storage.getItem(USER_MARGIN_TABLE_SORT) || {};

function getListDefaultData() {
  return {
    data: {},
    retryAfter: undefined,
    combinedData: [],
    dataCached: [],
    filters: getFilterFromStorage(),
    updateTime: new Date(),
    cacheUpdateTime: new Date(),
    filtersUpdateTime: new Date(),
    sorting: getSortFromStorage(),
    error: null,
    brokerError: null,
  };
}

const list = (
  state = {
    ...getListDefaultData(),
  },
  action
) => {
  switch (action.type) {
    case FETCH_USER_MARGIN_REQUEST:
      return { ...state, isFetching: true, error: null };
    case FETCH_USER_MARGIN_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        data: action.data.data,
        combinedData: action.combinedData,
        updateTime: new Date(),
      };
    case FETCH_USER_MARGIN_FAILURE:
      return { ...state, isFetching: false, error: action.error };
    case UPDATE_USER_MARGIN_RETRY_AFTER_TIMER:
      return { ...state, retryAfter: action.data, isFetching: false };
    case USER_MARGIN_LIST_CACHE:
      return {
        ...state,
        dataCached: action.data,
        cacheUpdateTime: new Date(),
      };
    case USER_MARGIN_LIST_UPDATE_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.data,
        },
        filtersUpdateTime: new Date(),
      };
    case USER_MARGIN_LIST_SORTING:
      return {
        ...state,
        sorting: action.data,
      };
    case RESET_USER_MARGIN:
      return { ...state, ...getListDefaultData() };
    default:
      return state;
  }
};

const userMargin = combineReducers({
  list,
});

export default userMargin;
